import React from "react";
import { connect } from 'react-redux';
import { useQuery } from "react-query";
import { useQueryClient } from "react-query";



import { fetchAdministrationMarques } from 'utils/queries';

import { postMarque, patchMarque, deleteMarque } from 'utils/posters';





import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';

import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import CircularProgress from '@mui/material/CircularProgress';
import Chip from '@mui/material/Chip';


import AddCircleIcon from '@mui/icons-material/AddCircle';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';


import FournisseurGestionAutocomplete from 'components/Shared/FournisseurGestionAutocomplete';
import LoadingButton from 'components/Shared/LoadingButton';
import SkeletonTable from 'components/Shared/SkeletonTable';
import QualificationTextField from 'components/Shared/QualificationTextField';


const headers = ["Marque", "Exclusive", "Fournisseurs", "Actions"];


const defaultMarque = {
    id: 0,
    fournisseurs: [],
    nom: "",
    nouveauNom: "",
    marquePropre: false,
    creation: false
};

const AdministrationMarques = ({ postMarque, patchMarque, deleteMarque }) => {

    const [edited, setEdited] = React.useState(defaultMarque);
    const [marqueToRemove, setMarqueToRemove] = React.useState(null);
    const [fournisseurToAdd, setFournisseurToAdd] = React.useState(null);
    const [saving, setSaving] = React.useState(false);


    const queryClient = useQueryClient();
    const administrationMarquesQuery = useQuery(["AdministrationMarques"], fetchAdministrationMarques);

    //// Memorisation de la liste des marques
    const marques = React.useMemo(() => {

        let result = [];
        if (administrationMarquesQuery.isLoading || administrationMarquesQuery.error) {
            return result;
        }

        result = administrationMarquesQuery.data.marques.map(m => {

            let marque = { ...m };
            marque.fournisseurs = administrationMarquesQuery.data.liaisons.filter(liaison => liaison.marqueId === marque.id).map(l => {
                let fournisseur = administrationMarquesQuery.data.fournisseurs.find(f => f.id === l.fournisseurId);
                return fournisseur;
            });

            return marque;
        });

        // console.log("Memorisation de la liste des marques", result);

        return result;

    }, [administrationMarquesQuery.data]);



    // Memorisation de la validité du tableau d'ajout de fournisseur
    const editedValid = React.useMemo(() => {

        let valid = { nom: false };

        if (!edited.nouveauNom.trim()) {
            return valid;
        }

        let testNom = edited.nouveauNom.trim().toUpperCase();
        let duplicate = null;
        if (edited.creation) {
            duplicate = marques.find(m => m.nom.toUpperCase() === testNom);
        }
        else {
            duplicate = marques.find(m => m.id !== edited.id && m.nom.toUpperCase() === testNom);
        }
        if (duplicate) {

            valid.nomHelperText = "Nom de marque déjà utilisé";
        }
        else {
            valid.nom = true;
        }


        return valid;

    }, [edited.nouveauNom]);





    const handleNouvelleMarque = async () => {
        setSaving(true);

        console.log("handleNouvelleMarque", edited);

        let nouvelleMarque = { nom: edited.nouveauNom, marquePropre: edited.marquePropre };

        var result = await postMarque(nouvelleMarque);
        setSaving(false);


        if (!result) {
            return;
        }

        setEdited(defaultMarque);
        queryClient.resetQueries("AdministrationMarques");
    };

    const handleRemoval = async () => {

        console.log("handleRemoval", marqueToRemove);

        setSaving(true);

        var result = await deleteMarque(marqueToRemove);
        setSaving(false);


        if (!result) {
            return;
        }

        setMarqueToRemove(null);
        queryClient.resetQueries("AdministrationMarques");


    };


    const patch = async () => {
        setSaving(true);

        console.log("patch", edited);

        var result = await patchMarque(edited);
        setSaving(false);


        if (!result) {
            return;
        }

        setEdited(defaultMarque);
        queryClient.resetQueries("AdministrationMarques");
    };


    const renderMarquesTable = () => {

        return (
            <Table size='small'>
                <TableHead>
                    <TableRow>
                        <TableCell>
                            Marque
                        </TableCell>
                        <TableCell>
                            Exclusive
                        </TableCell>
                        <TableCell>
                            Fournisseurs
                        </TableCell>
                        <TableCell>
                            Actions
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>

                    {marques.map(marque => {

                        let edition = edited.id === marque.id;
                        let showActions = edited.id === 0 || edition;

                        let style = { verticalAlign: "top" };
                        if (showActions) {
                            style = {
                                ...style,
                                "&:hover .MuiTableCell-root:last-child *:first-of-type": { display: 'inherit' }
                            }
                        }

                        return (
                            <TableRow key={marque.id} hover sx={style}>

                                <TableCell>
                                    {!edition && (<>

                                        {marque.nom}

                                    </>)}

                                    {edition && (<>
                                        <QualificationTextField
                                            label="Nom"
                                            required
                                            value={edited.nouveauNom}
                                            disabled={saving}
                                            helperText={editedValid.nomHelperText}
                                            error={!!editedValid.nomHelperText}
                                            onChange={e => { setEdited({ ...edited, nouveauNom: e.target.value }); }}
                                        />
                                    </>)}

                                </TableCell>
                                <TableCell style={{ fontWeight: marque.marquePropre ? "bold" : "normal" }}>

                                    {!edition && (<>

                                        {marque.marquePropre ? "OUI" : "NON"}

                                    </>)}

                                    {edition && (
                                        <FormControlLabel
                                            control={<Switch
                                                checked={edited.marquePropre}
                                                onChange={() => { setEdited({ ...edited, marquePropre: !edited.marquePropre }); }}
                                                color="secondary"
                                            />}
                                            label="Marque propre"
                                        />)}
                                </TableCell>


                                <TableCell>

                                    {!edition && (
                                        <Stack direction={"column"} spacing={1}>
                                            {marque.fournisseurs.map(fournisseur => {
                                                return (
                                                    <Box sx={{ flexGrow: 0 }} key={fournisseur.id}>
                                                        <Chip

                                                            label={`${fournisseur.code} - ${fournisseur.nom}`}
                                                            variant="outlined"
                                                        />
                                                    </Box>);
                                            })}

                                        </Stack>
                                    )}

                                    {edition && (

                                        <Stack direction={"column"} spacing={1}>
                                            <Stack direction={"row"}>

                                                <Box sx={{ flexGrow: 1 }}>
                                                    <FournisseurGestionAutocomplete
                                                        autoFocus
                                                        onChange={e => { setFournisseurToAdd(e); }}
                                                        error={false}
                                                        helperText={""}
                                                        autoriseSAV
                                                    />
                                                </Box>

                                                <IconButton
                                                    onClick={() => {
                                                        setEdited({ ...edited, fournisseurs: [...edited.fournisseurs, { ...fournisseurToAdd }] });
                                                        setFournisseurToAdd(null);
                                                    }}
                                                    color="success"
                                                    disabled={!fournisseurToAdd}
                                                >
                                                    <AddCircleIcon />
                                                </IconButton>

                                            </Stack>

                                            {edited.fournisseurs.map(fournisseur => {
                                                return (
                                                    <Box sx={{ flexGrow: 0 }} key={fournisseur.id}>
                                                        <Chip

                                                            label={`${fournisseur.code} - ${fournisseur.nom}`}
                                                            variant="outlined"
                                                            onDelete={() => setEdited({ ...edited, fournisseurs: edited.fournisseurs.filter(x => x.id !== fournisseur.id) })}
                                                        />
                                                    </Box>);
                                            })}

                                        </Stack>
                                    )}












                                </TableCell>


                                <TableCell sx={{ paddingTop: '0px', paddingBottom: '0px' }}>
                                    <Box sx={!edition ? { display: 'none' } : {}}>

                                        {!edition && (
                                            <>
                                                <IconButton sx={{ paddingTop: '0px', paddingBottom: '0px' }} onClick={() => setEdited({ ...marque, nouveauNom: marque.nom, creation: false })} disabled={saving} size="small"><EditIcon fontSize="small" /></IconButton>
                                                <IconButton sx={{ paddingTop: '0px', paddingBottom: '0px' }} onClick={() => setMarqueToRemove(marque)} disabled={saving} size="small"><DeleteIcon fontSize="small" /></IconButton>
                                            </>
                                        )}

                                        {edition && (

                                            <>

                                                {!saving && (
                                                    <>
                                                        <IconButton onClick={() => setEdited(defaultMarque)} color="error"><CancelIcon /></IconButton>
                                                        <IconButton onClick={patch} color="success" disabled={!editedValid.nom}><CheckCircleIcon /></IconButton>
                                                    </>
                                                )}

                                                {saving && (<CircularProgress color="secondary" size={16} />)}
                                            </>

                                        )}

                                    </Box>
                                </TableCell>

                            </TableRow>
                        );

                    })}

                </TableBody>

            </Table>
        );

    };


    const renderNouvelleMarqueDialog = () => {

        return (

            <Dialog open={edited.id === 0 && edited.creation}>

                <DialogTitle>Nouvelle marque</DialogTitle>

                <DialogContent>
                    <Stack mt={1}>
                        <QualificationTextField
                            label="Nom"
                            required
                            autoFocus
                            value={edited.nouveauNom}
                            disabled={saving}
                            helperText={editedValid.nomHelperText}
                            error={!!editedValid.nomHelperText}
                            onChange={e => { setEdited({ ...edited, nouveauNom: e.target.value }); }}
                        />
                    </Stack>

                    <FormControlLabel
                        control={<Switch
                            checked={edited.marquePropre}
                            onChange={() => { setEdited({ ...edited, marquePropre: !edited.marquePropre }); }}
                            color="secondary"
                        />}
                        label="Marque propre"
                    />

                </DialogContent>

                <DialogActions>

                    <Button
                        disabled={saving}
                        onClick={() => { setEdited(defaultMarque) }}
                    >
                        Annuler
                    </Button>

                    <LoadingButton
                        pending={saving}
                        onClick={handleNouvelleMarque}
                        disabled={!editedValid.nom}
                        variant="contained"
                        color="secondary"
                        label="Ajouter"
                    />

                </DialogActions>

            </Dialog>

        );

    };


    const renderMarqueToRemoveDialog = () => {

        return (

            <Dialog open={marqueToRemove !== null}>

                <DialogTitle>Suppression d'une marque</DialogTitle>

                <DialogContent>
                    {marqueToRemove !== null && (

                        <span>Voulez-vous vraiment supprimer la marque {marqueToRemove.nom}</span>

                    )}


                </DialogContent>

                <DialogActions>

                    <Button
                        disabled={saving}
                        onClick={() => { setMarqueToRemove(null) }}
                    >
                        Annuler
                    </Button>

                    <LoadingButton
                        pending={saving}
                        onClick={handleRemoval}
                        variant="contained"
                        color="secondary"
                        label="Supprimer"
                    />

                </DialogActions>

            </Dialog>

        );

    };


    return (
        <>
            <Stack direction={"row"}>
                <Typography gutterBottom variant="h5" sx={{ flexGrow: 1 }}>
                    Administration des Marques et Détection Marque Propre
                </Typography>

                <Button onClick={() => { setEdited({ ...defaultMarque, creation: true }); }}>Nouvelle</Button>
            </Stack>

            {renderNouvelleMarqueDialog()}
            {renderMarqueToRemoveDialog()}

            {administrationMarquesQuery.isLoading && (
                <SkeletonTable headers={headers} />
            )}

            {administrationMarquesQuery.error && (
                <p>Erreur du chargement des marques, veuillez contacter le support.</p>
            )}

            {!administrationMarquesQuery.isLoading && !administrationMarquesQuery.error && (
                <Paper>
                    {renderMarquesTable()}
                </Paper>
            )}

        </>
    );

}




const mapDispatchToProps = {
    postMarque,
    patchMarque,
    deleteMarque
};

export default connect(null, mapDispatchToProps)(AdministrationMarques);